import { Navigate, useParams } from "react-router-dom";
import { useVisitorRole } from "../../utils/useVisitorRole";

/** Legacy `/app/visitors/:id/edit` — redirect to inline edit on register/control. */
export default function EditVisitorRedirect() {
  const { id } = useParams();
  const perms = useVisitorRole();
  const base = perms.isAdmin ? "/app/visitors/control" : "/app/visitors";

  return (
    <Navigate
      to={base}
      replace
      state={{ editVisitorId: id ? Number(id) : null }}
    />
  );
}
